import { render, staticRenderFns } from "./ColunaPesquisa.vue?vue&type=template&id=32b4767d&scoped=true"
import script from "./ColunaPesquisa.vue?vue&type=script&lang=js"
export * from "./ColunaPesquisa.vue?vue&type=script&lang=js"
import style0 from "./ColunaPesquisa.vue?vue&type=style&index=0&id=32b4767d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4767d",
  null
  
)

export default component.exports